export default __webpack_public_path__ + "static/media/warning--road-closed--g3.c3c7cc6d.png";